import React from "react";
import { useMutation } from "react-query";
import { cancelNamePurchase } from "./gateway";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

export default function useCancelNamePurchase({
  nameTitlePurchaseAppId,
}: {
  nameTitlePurchaseAppId: number | string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: cancelNamePurchase,
    onSuccess: (data, variables, context) => {
      enqueueSnackbar(data?.data?.message, { variant: "success" });
      navigate(`/namePurchase/companyNamesDetails/${nameTitlePurchaseAppId}`);
    },
    onError: (error: AxiosError<any>) => {
      enqueueSnackbar(t(error?.response?.data), { variant: "error" });
      navigate(`/namePurchase/companyNamesDetails/${nameTitlePurchaseAppId}`);
    },
  });
}
